export default __webpack_public_path__ + "static/media/chat13.03961758.png";